import type { InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = ({ className, invalid = false, ...props }: InputProps) => (
  <input
    className={cn(
      'min-h-14 w-full rounded-md border-2 bg-white px-4 text-base text-ink placeholder:text-ink-soft',
      'focus:border-teal-ink focus:outline-none disabled:bg-sand-soft disabled:text-ink-soft',
      invalid ? 'border-danger' : 'border-line',
      className
    )}
    aria-invalid={invalid || undefined}
    {...props}
  />
);
